import {ResponseMessages} from '@/class/http';
export enum FileType {
  original = 'original',
  thumbnail = 'thumbnail'
}

export interface FilesInitState {
  files: Files[]
  profile: Files[]
}

export class ResponseFiles extends ResponseMessages {
  public data!: Files[];
}

export interface ReferenceID {
  refId: string
  private: boolean
  fileType: FileType
}

export interface Files {
  _id: string;
  refId: string;
  primary: boolean;
  private: boolean;
  filePath: string;
  ownerId: string;
  documentStatus: boolean;
  fileType: string;
}

export interface DeleteFile {
  path: string;
  id: string;
}
